import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "matchup-grid" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "plus"
}
const _hoisted_5 = {
  key: 1,
  class: "links"
}
const _hoisted_6 = { class: "d-flex justify-center flex-column align-center ga-4" }
const _hoisted_7 = { class: "d-flex justify-center align-center ga-4" }

import { ref, onMounted } from 'vue';

import { getClassicWc3Races } from '@/services/wc3/wc3.service';
import { getSocialPlatforms } from '@/services/common/common.service';
import type { CreateMatchupTableDto, MatchupCell, MatchupLink } from '@/services/drUniversity/matchups/matchups.model';

import liquipediaIcon from '@/assets/imgs/liquipedia.png';
import youtubeIcon from '@/assets/imgs/youtube.png';
import tiktokIcon from '@/assets/imgs/tiktok.png';
import soopIcon from '@/assets/imgs/soop.png';
import twitchIcon from '@/assets/imgs/twitch.png';
import instagramIcon from '@/assets/imgs/instagram.webp';
import twitterIcon from '@/assets/imgs/twitter.png';
import redditIcon from '@/assets/imgs/reddit.png';
import w3championsIcon from '@/assets/imgs/w3c.png';

interface Props {
  initialData?: CreateMatchupTableDto;
  onSubmit: (payload: CreateMatchupTableDto) => Promise<void>;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MatchupsTableForm',
  props: {
    initialData: {},
    onSubmit: { type: Function },
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const name = ref('');

const races = ref<{ id: number; name: string }[]>([]);
const socialPlatforms = ref<{ id: number; name: string }[]>([]);

const cells = ref<Record<string, MatchupCell>>({});

const dialogVisible = ref(false);
const editingKey = ref<string | null>(null);
const tempLinks = ref<MatchupLink[]>([]);

const platformIcons: Record<string, string> = {
  tiktok: tiktokIcon,
  youtube: youtubeIcon,
  liquipedia: liquipediaIcon,
  soop: soopIcon,
  twitch: twitchIcon,
  instagram: instagramIcon,
  twitter: twitterIcon,
  reddit: redditIcon,
  w3champions: w3championsIcon,
};

onMounted(async () => {
  const [racesRes, platformsRes] = await Promise.all([getClassicWc3Races(), getSocialPlatforms()]);
  races.value = racesRes ?? [];
  socialPlatforms.value = platformsRes ?? [];

  for (const r1 of races.value) {
    for (const r2 of races.value) {
      const key = `${r1.id}-${r2.id}`;
      cells.value[key] = {
        rowRaceId: r1.id,
        colRaceId: r2.id,
        links: [],
      };
    }
  }

  if (props.initialData) {
    name.value = props.initialData.name;

    for (const cell of props.initialData.cells) {
      const key = `${cell.rowRaceId}-${cell.colRaceId}`;
      cells.value[key].links = cell.links ?? [];
    }
  }
});

function openDialog(key: string) {
  editingKey.value = key;
  tempLinks.value = JSON.parse(JSON.stringify(cells.value[key].links || []));
  dialogVisible.value = true;
}

function saveDialog() {
  if (editingKey.value) {
    cells.value[editingKey.value].links = JSON.parse(JSON.stringify(tempLinks.value));
  }
  dialogVisible.value = false;
}

function addLink() {
  tempLinks.value.push({
    platformId: socialPlatforms.value[0]?.id ?? null,
    url: '',
    text: '',
  });
}

function removeLink(index: number) {
  tempLinks.value.splice(index, 1);
}

async function handleSubmit() {
  const payload: CreateMatchupTableDto = {
    name: name.value,
    cells: Object.values(cells.value),
  };

  await props.onSubmit(payload);
}

function getPlatformIcon(platformId: number | undefined) {
  const platform = socialPlatforms.value.find((p) => p.id === platformId);
  if (!platform) return;
  return platformIcons[platform.name.toLowerCase()];
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, {
      modelValue: name.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
      label: "Name",
      outlined: "",
      required: ""
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "corner" }, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(races.value, (race) => {
        return (_openBlock(), _createElementBlock("div", {
          key: race.id,
          class: "header"
        }, _toDisplayString(race.name), 1))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(races.value, (rowRace) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: 'row-' + rowRace.id
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(rowRace.name), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(races.value, (colRace) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `cell-${rowRace.id}-${colRace.id}`,
              class: "cell",
              onClick: ($event: any) => (openDialog(`${rowRace.id}-${colRace.id}`))
            }, [
              (cells.value[`${rowRace.id}-${colRace.id}`].links?.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "+"))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cells.value[`${rowRace.id}-${colRace.id}`].links, (l, index) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: index,
                        size: "small",
                        class: "d-flex align-center justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: getPlatformIcon(l.platformId),
                            height: 18,
                            width: 18
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
            ], 8, _hoisted_3))
          }), 128))
        ], 64))
      }), 128))
    ]),
    _createVNode(_component_v_btn, {
      loading: props.loading,
      onClick: handleSubmit,
      block: "",
      color: "primary",
      class: "mt-4"
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createTextVNode(" Save Matchup Table ", -1)
      ]))]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_v_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      width: "840",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Edit Links", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                class: "mb-3",
                width: 200,
                color: "secondary",
                variant: "elevated",
                onClick: addLink
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-plus", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createTextVNode(" Add Link ", -1))
                ]),
                _: 1
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tempLinks.value, (link, i) => {
              return (_openBlock(), _createBlock(_component_v_row, {
                key: i,
                class: "py-2",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "pa-4 d-flex align-center flex-wrap ga-2",
                        elevation: "1",
                        rounded: "lg"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: link.platformId,
                            "onUpdate:modelValue": ($event: any) => ((link.platformId) = $event),
                            items: socialPlatforms.value,
                            "item-title": "name",
                            "item-value": "id",
                            label: "Platform",
                            outlined: "",
                            "hide-details": "",
                            class: "social-input"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: link.url,
                            "onUpdate:modelValue": ($event: any) => ((link.url) = $event),
                            label: "URL",
                            outlined: "",
                            "hide-details": "",
                            class: "social-input"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: link.text,
                            "onUpdate:modelValue": ($event: any) => ((link.text) = $event),
                            label: "Description",
                            outlined: "",
                            "hide-details": "",
                            class: "social-input"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_v_btn, {
                            icon: "",
                            color: "error",
                            variant: "tonal",
                            class: "delete-btn",
                            onClick: ($event: any) => (removeLink(i))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                color: "primary",
                width: 200,
                class: "mt-4",
                onClick: saveDialog
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Save ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "surface",
                width: 200,
                class: "mt-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})